import { useEffect, useState } from 'react';
import { NutritionCustomerAnalyticsInfo } from '../../../../../interfaces/NutritionCustomerAnalyticsInfo';
import { nutritionHomeService } from '../../../../../services/nutritionHomeService';
import { DateRangePreset } from '../../../../../../shared/constants/dateRangePreset';
import { getDateRangeByPreset } from '../../../../../../shared/utils/getDateRangeByPreset/getDateRangeByPreset';

type UseCustomerAnalyticsParams = {
  dateRangePreset: DateRangePreset;
};

type UseCustomerAnalyticsReturn = {
  customerAnalytics: NutritionCustomerAnalyticsInfo | null;
};

export const useCustomerAnalytics = ({
  dateRangePreset,
}: UseCustomerAnalyticsParams): UseCustomerAnalyticsReturn => {
  const [customerAnalytics, setCustomerAnalytics] =
    useState<NutritionCustomerAnalyticsInfo | null>(null);

  const fetchCustomerAnalytics = async () => {
    const dateRange = getDateRangeByPreset(dateRangePreset);

    const data = await nutritionHomeService.getCustomerAnalytics(dateRange);
    setCustomerAnalytics(data);
  };

  useEffect(() => {
    fetchCustomerAnalytics();
  }, [dateRangePreset]);

  return { customerAnalytics };
};
